import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _LoanCurrency, _LoanDestination } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { Singleton } from "../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { BasicPage } from "../../../../../theme/Component/BasicPage";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { MyEditor } from "../../../../../theme/Component/MyEditor";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { CurrencyEditor } from "../../../../../erp/cellEditor/Currency/CurrencyEditor";




export const LoanCurrency = () => {

    const loanCurrency = useDataBean(_LoanCurrency);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        loanCurrency.instance.getLoanCurrencyCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        loanCurrency.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        loanCurrency.deleteItemVoid(loanCurrency.bean.IDLoanCurrency).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        loanCurrency.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDLoanCurrency', visible: true },

        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Moneda', property: 'IDCurrency', visible: true },
        { title: 'Unidades de Conversión', property: 'UnitValue', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${loanCurrency.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Tipo de Moneda">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={loanCurrency.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={loanCurrency.bean.Name} onChange={loanCurrency.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                            <div className="col-md-6">
                                <CurrencyEditor id={loanCurrency.bean.IDCurrency} onchange={(e: any) => { loanCurrency.setBean({ ...loanCurrency.bean, "IDCurrency": e }) }}></CurrencyEditor>
                            </div>
                            <div className="col-md-6">
                                <label>Unidades de Conversión</label>
                                <input type="text" name="UnitValue" className="form-control" value={loanCurrency.bean.UnitValue} onChange={loanCurrency.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <MyEditor val={loanCurrency.bean.Description} onChange={(e: any) => { loanCurrency.setBean({ ...loanCurrency.bean, 'Description': e }) }} ></MyEditor>
                            </div>

                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {loanCurrency.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}